export const FLITCHING_DONE_LIST_REQUEST = "FLITCHING_DONE_LIST_REQUEST";
export const FLITCHING_DONE_LIST_SUCCESS = "FLITCHING_DONE_LIST_SUCCESS";
export const FLITCHING_DONE_LIST_FAILED = "FLITCHING_DONE_LIST_FAILED";
